<app-venda-modal-v2
  *ngIf="selectedOrcamento"
  [isOpen]="isVendasModalOpen"
  [orcamento]="selectedOrcamento"
  [tipoAcao]="'NOVA_VENDA'"
  [clienteComRestricao]="!!selectedOrcamento.restricaoAtiva"
  (closeModal)="closeModalVendas($event)">
</app-venda-modal-v2>
<app-orcamento-pdf></app-orcamento-pdf>

<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Orçamentos</h1>
    <button class="btn btn-primary" (click)="novoOrcamento()">Incluir Novo Orçamento</button>
  </div>
  <hr />

  <div class="mb-3">
    <div class="input-group">
      <input type="text" class="form-control" placeholder="Pesquisar por Nome do Cliente..." [(ngModel)]="searchTerm" (keyup.enter)="search()">
      <button class="btn btn-outline-secondary" type="button" (click)="search()">Pesquisar</button>
      <button class="btn btn-outline-secondary" type="button" (click)="limparBusca()" [disabled]="!searchTerm">Limpar</button>
    </div>
  </div>

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Nome Cliente</th>
          <th scope="col" class="text-center">Valor Total</th>
          <th scope="col" class="text-center">Data Orçamento</th>
          <th scope="col" class="text-center">Valido até</th>
          <th scope="col" class="text-center">Dias em Aberto</th>
          <th scope="col" class="text-center">Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let orcamento of displayedOrcamentos">
          <th scope="row">{{ orcamento.id }}</th>
          <td>{{ orcamento.nomeCliente }}</td>
          <td class="text-center">{{ orcamento.valorTotal | currency:'BRL' }}</td>
          <td class="text-center"> {{ orcamento.dataOrcamento | date:'dd/MM/yyyy' }}</td>
          <td class="text-center"> {{ orcamento.validadeOrcamento | date:'dd/MM/yyyy' }}</td>
          <td class="text-center">{{ orcamento.diasEmAberto }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-warning btn-sm me-2" (click)="editarOrcamento(orcamento.id)">Editar</button>
            <button type="button" class="btn btn-success btn-sm me-2" [attr.data-testid]="'btn-converter-' + orcamento.id" (click)="converterEmVenda(orcamento)">Converter</button>
            <button type="button" class="btn btn-info btn-sm me-2" (click)="imprimirOrcamento(orcamento.id)">Imprimir</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <nav *ngIf="totalPages > 1" aria-label="Page navigation" class="pagination-container">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 0">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(0)">Primeira</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === 0">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage - 1)">Anterior</a>
      </li>
      <li class="page-item" *ngFor="let page of pages" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(page)">{{ page + 1 }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(currentPage + 1)">Próxima</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage >= totalPages - 1">
        <a class="page-link" href="#" (click)="$event.preventDefault(); setPage(totalPages - 1)">Última</a>
      </li>
    </ul>
  </nav>
</div>
